import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getAnexosColumns } from './tanStackColumns';

const AnexosTable = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  setPaginationState,
  onRowClick,
  onExcluir,
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled
}) => {
  const columns = getAnexosColumns(
    onExcluir,
    selectedIds,
    onToggleSelect,
    onToggleSelectAll,
    allPageSelected,
    selectAllDisabled
  );

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          columns={columns}
          data={data}
          onRowClick={(row) => {
            if (onRowClick) onRowClick(row);
          }}
          isSortable={true}
          withPagination={true}
          manualPagination={true}
          totalItems={totalRegistros}
          onPaginationChange={setPaginationState}
          controlledPagination={paginationState}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          initialState={{
            pageIndex: paginationState?.pageIndex || 0,
            pageSize: paginationState?.pageSize || 10
          }}
          enableColumnConfig={true}
          columnConfigKey="anexos-columns"
          enableExportExcel={true}
          exportFileName="Anexos"
          enableRowColors={true}
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default AnexosTable;
